import { render, staticRenderFns } from "./index.vue?vue&type=template&id=59294781&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59294781",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59294781')) {
      api.createRecord('59294781', component.options)
    } else {
      api.reload('59294781', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=59294781&scoped=true&", function () {
      api.rerender('59294781', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/base/corp/index.vue"
export default component.exports